<template>
    <b-modal
        id="feedback-reply"
        title="Reply to Feedback"
        ref="replyModal"
        centered
        @shown="resizePhoto">
        <b-container>
            <div class="profile-wrap">
                <div class="profile-img mb-2 mx-auto d-flex rounded-circle border border-white">
                    <img
                        :src="feedbackInfo.profile_image === '' ? 'https://proxy.api-rush.loyaltyco.xyz/customer-service/default/default.jpg' : feedbackInfo.profile_image"
                        :alt="feedbackInfo.customer_name"
                        :class="{'w-100': avatar_class.width, 'h-100': avatar_class.height}"
                        ref="avatar">
                </div>
                <p class="profile-name text-center mb-0">{{ feedbackInfo.customer_name }}</p>
                <p class="profile-no text-center mb-2">{{ feedbackInfo.mobile_number }}</p>
            </div>
            <div class="comment-wrap mt-3">
                <div class="sender">
                    <label class="mr-2">{{ feedbackInfo.firstname }}</label>
                    <span class="label-helper">{{ feedbackInfo.date_created }} {{ feedbackInfo.time_created }}</span>
                </div>
                <div class="comment-msg p-3 rounded">
                    {{ feedbackInfo.message }}
                </div>
                <template v-if="feedbackInfo.reply !== null">
                    <div class="sender mt-3">
                        <label class="mr-2">Admin {{ feedbackInfo.replied_by }}</label>
                        <span class="label-helper">{{ feedbackInfo.date_replied }}  {{ feedbackInfo.time_replied }}</span>
                    </div>
                     <div class="comment-msg p-3 rounded bg-white border">
                        {{ feedbackInfo.reply }}
                    </div>
                    
                </template>
            </div>
            <div v-if="hideReply !== true">
                <hr class="form-divider my-4">
                <b-form :show="hideReply == false">
                    <b-row no-gutters>
                        <b-col md="4">
                            <h6 class="main-label" for="reply">Your Reply</h6>
                        </b-col>
                        <b-col md="8">
                            <b-form-group
                                label="Message"
                                label-for="admin_reply"
                                label-class="secondary-label">
                                <b-form-textarea
                                    rows="5"
                                    placeholder="Enter Message"
                                    v-model="form.reply"
                                    class="feedback-text">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </b-container>
        <div slot="modal-footer" v-bind:class="{ 'd-none': hideReply }">
            <b-btn variant="ghost" v-bind:disabled="loading || enableSend" @click="handleCancel('feedback-reply')" class="mr-1 btn-cancel">
                Cancel
            </b-btn>
            <b-btn variant="primary" v-bind:disabled="loading || enableSend" class="ml-1" @click="submitReply">
                <template v-if="loading">
                    Sending...
                </template>
                <template v-else>
                    Send
                </template>
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ReplyToFeedback",
    data() {
        return {
            enableSend: true,
            adminReply: "",
            customer: {
                name: "John Vincent Doe",
                avatar: require("../../assets/images/dummy_customer_avatar.jpg"),
                mobile: "+63917 2345678",
                timestamp: "Jan 1, 2018  1:30 PM",
                comment:
                    "I love the drink! Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            },
            form: {
                reply: ""
            },
            hideReply: false,
            avatar_class: {
                width: false,
                height: false
            }
        };
    },
    computed: {
        ...mapState("feedbacks", ["feedbackInfo", "loading"],),
        customerFirstName: function() {
            return this.customer.name.split(" ")[0];
        }
    },
    methods: {
        submitReply: function() {
            let _this = this;

            this.$store.commit("feedbacks/setReply", this.form.reply);
            this.$store.dispatch("feedbacks/sendReply").then(function() {
                if (_this.errors == null) {
                    _this.form.reply = "";
                }
            });
        },
        resizePhoto() {
            let avatar_width = this.$refs["avatar"].clientWidth;
            let avatar_height = this.$refs["avatar"].clientHeight;
            if(avatar_width > avatar_height) {
                this.avatar_class.height = true;
            } else if(avatar_height > avatar_width) {
                this.avatar_class.width = true;
            } else {
                this.avatar_class.width = true;
            }
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        handleCancel(modal) {
            this.hideModal(modal);
        },
    },
    watch: {
        "form.reply": function() {
            this.form.reply.length !== 0
                ? (this.enableSend = false)
                : (this.enableSend = true);
        },
        "feedbackInfo.reply": function() {
            this.feedbackInfo.reply !== null
                ? (this.hideReply = true)
                : (this.hideReply = false);
        }
    }
};
</script>
